import React from 'react'
import { FreeBadge } from '../Badges/FreeBadge'
import { MembersBadge } from '../Badges/MembersBadge'
import { PremiumBadge } from '../Badges/PremiumBadge'

type BadgeHeaderProps = {
    badgeType: 'free' | 'membersOnly' | 'premium' | 'none'
    premiumText?: {
        prevPrice: number
        newPrice: number
    }
}

export const BadgeHeader = ({ badgeType = 'none', premiumText }: BadgeHeaderProps) => {
    if (badgeType === 'none') {
        return null
    }

    return (
        <div className="absolute top-3 right-4 justify-center items-center flex">
            {badgeType === 'free' ? <FreeBadge /> : null}
            {badgeType === 'membersOnly' ? <MembersBadge /> : null}
            {badgeType === 'premium' ? (
                <PremiumBadge
                    prevPrice={premiumText?.prevPrice}
                    newPrice={premiumText?.newPrice}
                />
            ) : null}
        </div>
    )
}
